module.exports = __webpack_public_path__ + "static/media/Jam6.721640a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/Jam6.svg
// module id = 607
// module chunks = 0